import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  taxIdInformationDefault: {
    description: 'description to clarify tax identifier modal',
    defaultMessage:
      'ShipStation only offers B2B services. Per government guidelines, local taxes will be applied to those who do not provide a {taxIdName} number. To avoid this please enter your {taxIdName} information. Once this is set, it can not be changed. <a>Learn more about {taxIdName} Requirements.</a>',
    id: 'rr2ae8',
  },
  taxIdAUInformation: {
    description: 'description to clarify tax identifier modal for AU',
    defaultMessage:
      'Per government guidelines, GST will be applied to all Australian accounts. To receive a GST-compliant invoice and reclaim GST, please enter your {taxIdName}. <a>Learn more about GST Requirements.</a>',
    id: 't5zX8u',
  },
  taxIdCAInformation: {
    description: 'description to clarify tax identifier modal',
    defaultMessage:
      'Per government guidelines, GST/HST will be applied to all Canadian accounts. To receive a GST/HST-compliant invoice, please enter your Business Number (BN). <a>Learn more about GST/HST Requirements.</a>',
    id: 'mIgiBP',
  },
});
